export { positionElements, Positioning } from './ng-positioning';
export { PositioningService, PositioningOptions } from './positioning.service';



// WEBPACK FOOTER //
// ../../.tmp/positioning/index.ts